export const customersConstants = {
  GET_CUSTOMERS: "GET_CUSTOMERS",
  ACTIVATE_DEACTIVATE_CUSTOMER: "ACTIVATE_DEACTIVATE_CUSTOMER",
};
